import { OrgUser } from 'src/types';
import { Order } from '../Table/types';
import { getSortValue } from '../Table/utils/sorting';
import { Row } from './types';

const comparatorByEmail = (a: Row['cells'], b: Row['cells']) => {
  const emailA = getSortValue(a.email);
  const emailB = getSortValue(b.email);

  return emailA.localeCompare(emailB);
};

const comparatorByFullName = (
  a: Row['cells'],
  b: Row['cells'],
  orderCoef: number
) => {
  const nameA = getSortValue(a.fullName) || '';
  const nameB = getSortValue(b.fullName) || '';

  const equivalentCoef = nameA.localeCompare(nameB);
  if (!equivalentCoef) {
    return orderCoef * comparatorByEmail(a, b);
  }
  return equivalentCoef;
};

const comparatorByStatus = (
  a: Row['cells'],
  b: Row['cells'],
  orderCoef: number
) => {
  const userA = getSortValue(a.status);
  const userB = getSortValue(b.status);

  const equivalentCoef = userA.localeCompare(userB);

  if (!equivalentCoef) {
    return orderCoef * comparatorByFullName(a, b, orderCoef);
  }
  return equivalentCoef;
};

export const sortColumns = (
  order: Order,
  orderBy: string
): ((a: Row['cells'], b: Row['cells']) => number) => {
  const orderCoef = order === Order.Desc ? -1 : 1;

  switch (orderBy) {
    case 'email':
      return (a: Row['cells'], b: Row['cells']) =>
        orderCoef * comparatorByEmail(a, b);
    case 'status':
      return (a: Row['cells'], b: Row['cells']) =>
        orderCoef * comparatorByStatus(a, b, orderCoef);
    default:
      return (a: Row['cells'], b: Row['cells']) =>
        orderCoef * comparatorByFullName(a, b, orderCoef);
  }
};

export const getFullName = (user: OrgUser) => {
  return `${user.firstName || ''} ${user.lastName || ''}`.trim();
};
